import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router';
import { Navbar } from '~components/customers/Navbar';
// import { Footer } from '~components/ui/Footer';
import { Header } from '~components/ui/Header';

export function NavbarLayout() {
  return (
    <Header.Provider>
      <Box display="flex" flexDir="column" height="100%">
        <Header
          background="white"
          color="gray.900"
          display="flex"
          justifyContent="center"
          transition="background 0.3s ease, boxShadow 0.3s ease"
          boxShadow="0px 2px 2px rgba(0, 0, 0, 0.05)"
        >
          <Navbar />
        </Header>

        <Box flex="1 0 auto">
          <Header.Spacer />
          <Outlet />
        </Box>

        {/* <Footer /> */}
      </Box>
    </Header.Provider>
  );
}
